import React from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';

type Props = {
  children: React.ReactNode;
  gap?: '20' | '24';
};

export function FormContent({ children, gap = '20' }: Props) {
  const formStyles = classNames(styles.formContent, styles[`gap-${gap}`]);
  return <div className={formStyles}>{children}</div>;
}

export default FormContent;
